/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/require-default-props */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { LanguageSwitcher } from "sunday-component";
import { useRouter } from "next/router";
import { GLOBAL_PARAMS } from "src/constants/params";
import { formatPathByLogicalGroupChannel, filterParams } from "src/utils/url";
import {
  ChangeLangContainer,
  ChangeLangItem,
  ChangeLangText,
  DrawerContainer,
  MenuButton,
  MenuItem,
  MenuSubMenu,
  MenuText,
  MobileMenu,
  MobileMenuContainer,
  MobileMenuLinkBar,
  MobileMenuLinkIcon,
} from "./MobileMainMenu.style";
import { HeaderMenu, Language } from "../../IHeader";

type OnChangeFunction = (language: Language) => any;

interface CustomMainMenuProps {
  availableLanguage: Language[];

  onChangeLanguage: OnChangeFunction;
  language: Language;
  showSwitch: boolean;
  menus?: HeaderMenu;
}

const MobileMainMenu = ({
  availableLanguage,
  onChangeLanguage,
  language,
  showSwitch,
  menus,
}: CustomMainMenuProps): JSX.Element => {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const { t, i18n } = useTranslation("layout");
  const router = useRouter();

  const channelPath =
    typeof router.query.channelPath === "object"
      ? router.query.channelPath?.[0]
      : router.query.channelPath;

  const handleGoToAffiliatePage = () => {
    router.push({
      pathname: formatPathByLogicalGroupChannel(`/${channelPath}/affiliate`),
      query: filterParams(router.query, GLOBAL_PARAMS),
    });
  };

  const triggerMobileMenu = () => setMobileMenuVisible(!mobileMenuVisible);
  const closeMobileMenu = () => setMobileMenuVisible(false);

  return (
    <>
      <MobileMenu>
        <MenuButton
          type="text"
          onClick={triggerMobileMenu}
          icon={<MenuOutlined width={24} height={24} />}
          size="large"
        />
        <Drawer
          closable={false}
          placement="right"
          onClose={closeMobileMenu}
          visible={mobileMenuVisible}
          width="300"
          bodyStyle={{
            padding: "0px",
          }}
        >
          <DrawerContainer>
            <MobileMenuContainer
              selectable={false}
              mode="inline"
              inlineIndent={14}
            >
              <ChangeLangContainer justify="space-between">
                <ChangeLangItem>
                  <ChangeLangText level={7}>
                    {t("header.changeLanguage")}
                  </ChangeLangText>
                </ChangeLangItem>
                <ChangeLangItem>
                  <LanguageSwitcher
                    availableLanguages={availableLanguage}
                    showSwitch={showSwitch}
                    onChangeLanguage={onChangeLanguage}
                    language={language}
                  />
                </ChangeLangItem>
              </ChangeLangContainer>
              <Menu.Divider />
              <MenuItem key="0">
                <a href={`https://easysunday.com/${i18n.language}/`}>
                  <strong>{t("header.home")}</strong>
                </a>
              </MenuItem>
              <Menu.Divider />
              <MenuSubMenu key="sub1" title={t("header.healthInsurance.title")}>
                <Menu.Item>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/health`}
                  >
                    {t("header.healthInsurance.lumpSum")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/axa-child-health`}
                  >
                    {t("header.healthInsurance.child")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/#accident`}
                  >
                    {t("header.healthInsurance.personalAccident")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a href={`https://retail.easysunday.com/${i18n.language}`}>
                    {t("header.healthInsurance.allProducts")}
                  </a>
                </Menu.Item>
                {/* Due to COVID-19 situation, we hide Sunday Hero as for now...
              <Menu.Item><a href={`https://easysunday.com/motor/sunday-hero`}>{t('sundayHero')}</a></Menu.Item>
              */}
              </MenuSubMenu>
              <MenuSubMenu key="sub2" title={t("header.motorInsurance.title")}>
                <Menu.Item>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/sunday-car-insurance-ev`}
                  >
                    {t("header.motorInsurance.ev")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://retail.easysunday.com/${i18n.language}/sunday-car-insurance`}
                  >
                    {t("header.motorInsurance.motor")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a href={`https://easysunday.com/${i18n.language}/motor`}>
                    {t("header.motorInsurance.allProducts")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://easysunday.com/${i18n.language}/motor/claim`}
                  >
                    {t("header.motorInsurance.claim")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://easysunday.com/${i18n.language}/motor/#partnergarage`}
                  >
                    {t("header.motorInsurance.sundayPartner")}
                  </a>
                </Menu.Item>
              </MenuSubMenu>
              <MenuSubMenu
                key="sub3"
                title={t("header.sundayHealthForBusiness.title")}
              >
                <Menu.Item>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/`}
                  >
                    {t("header.sundayHealthForBusiness.about")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/#owner`}
                  >
                    {t("header.sundayHealthForBusiness.forBusinessOwner")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://easysunday.com/${i18n.language}/our-product/health/#employee`}
                  >
                    {t("header.sundayHealthForBusiness.forEmployee")}
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a
                    href={`https://sundayinsurance.co.th/${i18n.language}/services/panel/?type=hospital-suncare`}
                  >
                    {t("header.sundayHealthForBusiness.sundayHospitalNetwork")}
                  </a>
                </Menu.Item>
              </MenuSubMenu>
              <MenuSubMenu key="sub5" title={t("header.gadgetWarranty.title")}>
                {/* HOTFIX: HOTFIX: Hide covid link, until we have green light from OIC
                <Menu.Item><a href={`https://easysunday.com/health/covid-19`}>{t('sundayFightCovid')}</a></Menu.Item> */}
                <Menu.Item>
                  <a href={`https://easysunday.com/${i18n.language}/warranty/`}>
                    {t("header.gadgetWarranty.claim")}
                  </a>
                </Menu.Item>
              </MenuSubMenu>
              <Menu.Divider />
              <MenuItem key="1">
                <MenuText onClick={handleGoToAffiliatePage}>
                  <strong>
                    {menus?.sundayAffiliate?.label ||
                      t("header.sundayAffiliate")}
                  </strong>
                </MenuText>
              </MenuItem>
              <MenuItem>
                <a
                  href={
                    menus?.faq?.href ||
                    `https://easysunday.com/${i18n.language}/faq`
                  }
                >
                  <strong>{menus?.faq?.label || t("header.faq")}</strong>
                </a>
              </MenuItem>
              <MenuItem key="3">
                <a href={menus?.blog?.href || `https://easysunday.com/blog`}>
                  <strong>{menus?.blog?.label || t("header.blog")}</strong>
                </a>
              </MenuItem>
              <MenuItem key="4">
                <a
                  href={
                    menus?.contactUs?.href ||
                    `https://easysunday.com/${i18n.language}/contact-us`
                  }
                >
                  <strong>
                    {menus?.contactUs?.label || t("header.contactus")}
                  </strong>
                </a>
              </MenuItem>
              <MenuItem key="5">
                <a href={menus?.news?.href || "https://about.easysunday.com"}>
                  <strong>{menus?.news?.label || t("header.about")}</strong>
                </a>
              </MenuItem>
              <Menu.Divider />
            </MobileMenuContainer>
            <MobileMenuLinkBar>
              <MobileMenuLinkIcon href="tel:+6620263355">
                <img
                  loading="lazy"
                  src="/static/icon-phone-darkgrey.svg"
                  alt="phone"
                  height="40"
                />
              </MobileMenuLinkIcon>
              <MobileMenuLinkIcon href="mailto:hello@easysunday.com">
                <img
                  loading="lazy"
                  src="/static/icon-email-darkgrey.svg"
                  alt="email"
                  width="50"
                />
              </MobileMenuLinkIcon>
              <MobileMenuLinkIcon href="line://ti/p/@easysunday">
                <img
                  loading="lazy"
                  src="/static/icon-line-darkgrey.svg"
                  alt="line"
                  width="44"
                />
              </MobileMenuLinkIcon>
            </MobileMenuLinkBar>
          </DrawerContainer>
        </Drawer>
      </MobileMenu>
    </>
  );
};

export default MobileMainMenu;
